export enum enumCmsPermissions {
  integrator = 'Integração via API (Totvs, JHSFPay, etc)',
  architect_invoice_create_update = 'Criar/Editar Notas fiscais de arquiteto',
  architect_invoice_list = 'Listar Notas fiscais de arquiteto',
  architect_invoice_approve = 'Aprovar Notas fiscais de arquiteto',
  architect_invoice_cancel = 'Cancelar Notas fiscais de arquiteto',
  architect_invoice_delete = 'Deletar Notas fiscais de arquiteto',
  architect_admin_menu = 'Menu de acesso à unidade de negócio dos arquitetos',
}